import { render, staticRenderFns } from "./LegalDocumentContent_jQRln1.vue?vue&type=template&id=345f59fb&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_jQRln1.vue?vue&type=style&index=0&id=345f59fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f59fb",
  null
  
)

export default component.exports